import { useEffect, useRef } from 'react';

export default function useClickOutside(handler) {
    const domNodeRef = useRef<HTMLElement | null>();

    useEffect(() => {
        const maybeHandler = (event) => {
            if (domNodeRef.current && !domNodeRef.current.contains(event.target)) {
                handler();
            }
        };

        document.addEventListener("mousedown", maybeHandler);

        return () => {
            document.removeEventListener("mousedown", maybeHandler);
        };
    }, [handler]);

    return domNodeRef;
}